export const white = '#ffffff';
export const black = '#000000';
export const primaryBG = '#F6F4F4';
export const primaryBGDark = '#041A2A';
export const primaryBGNightBlack = '#212121';

const colors = {
  red: {
    1200: '#DD0B24',
    1100: '#EB6180',
    1000: '#F9D2DB',
    900: '#260608',
    800: '#4B0D10',
    700: '#711318',
    600: '#C0103E',
    500: '#E21D4A',
    400: '#ED587A',
    300: '#DEDEDE',
    200: '#C9C9C9',
    100: '#FFFFFF',
  },
  blue: {
    1100: '#95C7EB',
    1000: '#2B8FD7',
    900: '#041A2A',
    800: '#113956',
    700: '#1A5681',
    600: '#2272AC',
    500: '#2B8FD7',
    400: '#60ABE1',
    300: '#95C7EB',
    200: '#CAE3F5',
    100: '#EAF4FB',
  },
  gray: {
    1500: '#6C6C6C',
    1400: '#333333',
    1300: '#DAE1E9',
    1200: '#E6E6E6',
    1100: '#8392A7',
    1000: '#8F8F8F',
    900: '#161616',
    800: '#2C2C2C',
    700: '#424242',
    600: '#585858',
    500: '#808080',
    400: '#999999',
    300: '#C2C2C2',
    200: '#DEDEDE',
    100: '#F2F2F2',
  },
};

export default {
  ...colors,
  white: '#ffffff',
  black: '#000000',

  light: {
    warning: {
      primary: '#DD0B24',
    },
    red: {
      primary: '#E21D4A',
      warning: '#DD0B24',
    },
    blue: {
      primary: '#2B8FD7',
      secondary: '#0D5C93',
      tertiary: '#3E79A5',
    },
    gray: {
      primary: '#DEDEDE',
      light: '#595959',
      active: '#C9C9C9',
    },
    green: {
      primary: '#24A83A',
      notification: '#5EBE5E',
    },
    black: {
      primary: '#282828',
      secondary: '#F6F4F4',
      tertiary: '#FFFFFF',
    },
    notifications: {
      red: '#FF0000',
      yellow: '#E2C92D',
      gold: '#BF9200',
      green: '#24A83A',
    },
  },
  dark: {
    red: {
      primary: '#E21D4A',
      light: '#CD585E',
      disabled: '#DD8F93',
    },
    blue: {
      primary: '#2B8FD7',
      secondary: '#71B5E4',
      tertiary: '#3E79A5',
    },
    gray: {
      primary: '#DEDEDE',
      light: '#F6F4F4',
      active: '#C9C9C9',
    },
    green: {
      primary: '#24A83A',
    },
    black: {
      primary: '#CFCFCF',
      secondary: '#AFB0B1',
      tertiary: '#CFCFCF',
    },
    notifications: {
      red: '#FF0000',
      yellow: '#E2C92D',
      gold: '#BF9200',
      green: '#24A83A',
    },
  },
};
